import * as T from '../../../components/Typography';
import { Row, Col } from '../../../components/Grid';
import InfoCard, { InfoCardWithButton } from '../../../components/InfoCard';
import { FACILITATOR } from '../../../constants/nav-routes';
import Loading from '../../../components/Loading';
import { useGetLearnersByCoachId } from '../../../api-calls/learners.queries';

const CoachLearnersSection = ({ coachId }) => {
  const {
    learners = [],
    isLoading: getLearnersLoading,
    error: getLearnersError,
  } = useGetLearnersByCoachId({ coachId });

  if (getLearnersLoading) {
    return <Loading />;
  }
  if (getLearnersError) {
    return (
      <T.P mb={2} mt={2} color="error">
        {getLearnersError.message}
      </T.P>
    );
  }

  return (
    <Row>
      {learners.length !== 0 ? (
        learners?.map((learner) => {
          return (
            <Col w={[4, 7, 7]} mt="3" key={learner.id}>
              <InfoCard
                firstColumnLabel="Learner ID"
                firstColumnValue={learner.learnerUniqueId}
                secondColumnLabel="Name"
                secondColumnValue={learner.firstName}
                to={FACILITATOR.LEARNER.replace(':userId', learner.id)}
              />
            </Col>
          );
        })
      ) : (
        <Col w={[4, 7, 7]} mt="2">
          <InfoCardWithButton />
        </Col>
      )}
    </Row>
  );
};
export default CoachLearnersSection;
